import { EMPTY_OBJECT } from './object.js';

/**
 * Resolves a `StyleValue` into a className and style object. If `value` is a string, it is
 * treated as a className. If `value` is an object, it is returned as-is.
 */
function resolveStyleValue(value) {
    if (!value)
        return EMPTY_OBJECT;
    if (typeof value === 'string')
        return { className: value };
    return value;
}

export { resolveStyleValue };
//# sourceMappingURL=style-value.js.map
